<template>
  <div>
    <AdvertComponent :country="country" :advert="advert" ad-slot="gigs_full_width" />
    <GigsPageHeader :filter-month="filterMonth" />
    <GigsList :gigs-by-month="gigsByMonth" />
  </div>
</template>

<script>
import gql from 'graphql-tag';

import GigsList from './list.vue';
import GigsPageHeader from './header.vue';
import AdvertComponent from '../advert/AdvertComponent.vue';

export default {
  apollo: {
    gigs: {
      query: gql`query gigsQuery($country: String!, $fromDate: ISO8601DateTime!) {
        gigs(country: $country, fromDate: $fromDate) {
          id
          title
          startsAt
          imageUrl
          venueName
          pricing
          genres
          pick
          url
        }
      }`,
      variables() {
        return {
          country: this.country,
          fromDate: this.fromDate,
        };
      },
    },
  },
  components: {
    GigsList,
    GigsPageHeader,
    AdvertComponent,
  },
  props: {
    country: {
      type: String,
      default: 'SG',
    },
    fromDate: {
      type: String,
      default: () => (new Date()).toISOString(),
    },
    advert: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      filterMonth: '',
      gigs: [],
    };
  },
  computed: {
    gigsByMonth() {
      const gigsByMonth = {};

      this.gigs.forEach((gig) => {
        if (!(`${gig.startsAt.slice(0, 7)}-01` in gigsByMonth)) {
          gigsByMonth[`${gig.startsAt.slice(0, 7)}-01`] = [];
        }
        gigsByMonth[`${gig.startsAt.slice(0, 7)}-01`].push(gig);
      });

      if (this.filterMonth !== '') {
        const filteredGigsByMonth = {};
        filteredGigsByMonth[this.filterMonth] = gigsByMonth[this.filterMonth];
        return filteredGigsByMonth;
      }

      return gigsByMonth;
    },
  },
  methods: {
    setFilterMonth(date) {
      this.filterMonth = date;
    },
  },
};
</script>
